import { useState } from 'react';
import './HistorialLecturas.css';
import GraficaHistorica from '../components/GraficaHistorica';
import Navbar from '../components/Navbar';
import VolverAlPanel from '../components/VolverAlPanel';


function HistorialLecturas() {
  const [sensorId, setSensorId] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [lecturas, setLecturas] = useState([]); 
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  

const consultarHistorico = async () => {
  if (!sensorId || !desde || !hasta) return;

  const token = localStorage.getItem('token');

  try {
    const res = await fetch(
      `https://iacloud.iapatagonia.cl/backend/lecturas/historicas?sensor_id=${sensorId}&desde=${desde}&hasta=${hasta}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) throw new Error('No autorizado');
    const data = await res.json();
    setLecturas(data);
  } catch (err) {
    console.error("Error al consultar lecturas:", err);
    alert("No tienes permisos para ver esta información.");
  }
};


  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <VolverAlPanel />
      <div style={{ padding: '2rem' }}>
        <h2>⚙️ Historial Lecturas</h2>
    
        <div className="historial-container">
          <h2>📅 Historial de Lecturas</h2>

          <div className="filtros">
            <input
              type="text"
              placeholder="ID del sensor"
              value={sensorId}
              onChange={(e) => setSensorId(e.target.value)}
            />
            <input
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
            />
            <input
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
            />
            <button onClick={consultarHistorico}>Consultar</button>
          </div>
          {lecturas.length === 0 && (
            <p style={{ color: '#999', marginTop: '2rem' }}>
              No se encontraron lecturas para los filtros seleccionados.
            </p>
          )}

          {lecturas.length > 0 && (
            <div className="graficas-historicas">
              <div className="grafica-historica-card">
                <h4>Oxígeno</h4>
                <GraficaHistorica datos={lecturas} tipo="oxigeno" />
              </div>

              <div className="grafica-historica-card">
                <h4>Temperatura</h4>
                <GraficaHistorica datos={lecturas} tipo="temperatura" />
              </div>

              <div className="grafica-historica-card">
                <h4>Saturación</h4>
                <GraficaHistorica datos={lecturas} tipo="saturacion" />
              </div>
            </div>
          )}
          {/* Aquí irán la gráfica y la tabla en los siguientes pasos */}
        </div>
      </div>
    </>
  );
}

export default HistorialLecturas;
